<template>
<PrimeBreadcrumb  :home="home" :model="items" style="margin-top: 0px;"></PrimeBreadcrumb>
<!--DataGrid -->
全部筆數{{datalength_all}}/已使用筆數{{datalength_used}}
  <div class="card">
    <PrimeDataTable
      ref="dt"
      :value="data"
      :paginator="true"
      :rows="10"
      dataKey="edelno"
      v-model:filters="filters2" filterDisplay="row" 
      :globalFilterFields="['edelno','isUsed','agentNo','custNo','epino']"
    >
       <template #header>
                    <div class="flex justify-content-end">
                        <span class="p-input-icon-left ">
                            <i class="pi pi-search" />
                            <PrimeInputText v-model="filters2['global'].value" placeholder="Keyword Search" />
                        </span>
                    </div>
                </template>
               

                

        <PrimeColumn field="edelno" header="配號" :sortable="true">
          
        </PrimeColumn>
        <PrimeColumn field="isUsed" header="使否使用" :sortable="true"></PrimeColumn>
        <PrimeColumn field="agentNo" header="代理" :sortable="true"></PrimeColumn>
        <PrimeColumn field="custNo" header="客戶" :sortable="true"></PrimeColumn>
        <PrimeColumn field="epino" header="提單號碼" :sortable="true"></PrimeColumn>
     
    </PrimeDataTable>
  </div>

    
</template>

<script>
import service from "../service/Appservice";
import {FilterMatchMode} from 'primevue/api';
export default {
   props: ["parentpkey","custparentpkey"],
  
  data() {
    return {
      item: null,
      selectedItems: null,
      data: null,
      isShowDialog: false,
      isShowCustRangeDialog: false,
      minno:null,
      maxno:null,
      filters2: {
                'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
                'edelno': {value: null, matchMode: FilterMatchMode.STARTS_WITH},
                'isUsed': {value: null, matchMode: FilterMatchMode.STARTS_WITH},
                'agentNo': {value: null, matchMode: FilterMatchMode.IN},
                'custNo': {value: null, matchMode: FilterMatchMode.EQUALS},
                'epino': {value: null, matchMode: FilterMatchMode.EQUALS}
            },

       home: {icon: 'pi pi-home', to: '/'},
            items: [
                {label: '代理'} ,
                {label: '代理維護'} ,
                {label: '代理區間號'} ,
                {label: '代理區間號使用狀況'} 
            ]
    };
  },
  computed: {
   
   user() {
     return this.$store.state.user;
    },
     clientId() {
     return this.$store.state.user?.clientId;
    },
     datalength_all(){
       return this.data?.length
     },
     datalength_used(){
       return this.data?.filter(x=>x.isUsed==true).length
     },


  },
  service: null,
  created() {
    this.service = new service();
  },
  mounted() {
    this.search();
  },
  methods: {
      

    ////////搜尋/////////////////////////////////////
    search() {
      this.service
        .getHCTedelno(this.parentpkey,this.custparentpkey)
        .then((data) => {
          console.log(data)
          this.data = [...data];
        });
    },
     
  }
}
</script>
 
 